"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportAdminRoutes = void 0;
const route_1 = require("../../route");
class SupportAdminRoutes extends route_1.Route {
    constructor() {
        super('admin/support');
    }
    getPayments() {
        return this.get('/payments');
    }
    getRequests() {
        return this.get('/requests');
    }
    getWithdrawals() {
        return this.get('/withdrawals');
    }
    getPendingWithdrawals() {
        return this.get('/withdrawals/pending');
    }
    approveWithdrawal(withdrawalId) {
        return this.put(`/withdrawals/${withdrawalId}`);
    }
    getVolumes() {
        return this.get('/volumes');
    }
    getBalances() {
        return this.get('/users');
    }
}
exports.SupportAdminRoutes = SupportAdminRoutes;
//# sourceMappingURL=support.js.map